export default function SkeletonDiv({
    w = '100px'
}) {
    return (<span className="placeholder" style={{ width: w}}></span>);
}